























import { getModule } from 'vuex-module-decorators';
import BrowseStore from '@/stores/product/browse.store';
import Component from 'vue-class-component';
import CategoryFilter from '@/views/search/filter/CategoryFilter.vue';
import ProductGroupings from '@/views/product/ProductGroupings.vue';
import AbstractBrowsePage from '@/views/browse/AbstractBrowsePage';
import Routes from '@/util/Routes';
import { Route } from 'vue-router';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import SortSelection from '@/views/search/filter/SortSelection.vue';
import SearchFilterControl from '@/views/search/filter/SearchFilterControl.vue';
import ShowMorePagination from '@/views/common/ShowMorePagination.vue';

@Component({
  components: {
    ShowMorePagination,
    SearchFilterControl,
    SortSelection,
    LoadingIndicator,
    CategoryFilter,
    ProductGroupings,
  },
})
export default class BrowseProducts extends AbstractBrowsePage {
  protected store = getModule(BrowseStore, this.$store);

  get currentCategoryId(): string {
    return this.$route.params.categoryId || '';
  }

  set currentCategoryId(categoryId: string) {
    this.$router.push({name: Routes.Category, params: {categoryId}});
  }

  public async mounted() {
    if (!this.$route.meta.isBack) {
      this.updateCategory(this.currentCategoryId);
    }
  }

  public async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    // Component is not re-mounted when only params change (e.g. SKU)
    // ref: https://router.vuejs.org/guide/advanced/navigation-guards.html#navigation-guards
    if (to.params.categoryId === '') {
      await this.$router.push({name: Routes.Categories});
    } else {
      await this.updateCategory(to.params.categoryId);
      next();
    }
  }
}

